<template>
  <div>
    <div v-if="!$store.state.slide.multipleChoiceStatus">
      <h2
        class="text-left slide-title-style mt-0"
        :class="{'mb-0': $store.state.slide.titleDesc}"
        v-if="$store.state.slide.title"
        :inner-html.prop="$store.state.slide.title | sanitize(true)"
      />
      <p class="text-left slide-title-style title-desc mb-3" v-if="$store.state.slide.titleDesc">
        {{ this.$store.state.slide.titleDesc }}
      </p>

      <div
        class="audio-control-slide p-16"
        v-if="$store.state.slide.audioLink && $store.state.slide.audioPlayOnAudience && $store.state.slide.id"
      >
        <AudioControl />
      </div>
      <div v-if="$store.state.slide.SlideOptions">
        <ScaleQuestion v-if="$store.state.slide.type == 'scale'" />
        <MultipleChoice v-else />
      </div>
    </div>
    <div
      class="no-data text-center"
      v-if="!$store.state.slide.title && !$store.state.slide.SlideOptions && !$store.state.slide.titleDesc || !$store.state.slide.title && !$store.state.slide.SlideOptions.length && !$store.state.slide.titleDesc"
    >
      {{ $t("blankSlide") }}
    </div>

    <div v-if="$store.state.slide.multipleChoiceStatus == 2">
      <SlideWaiting />
    </div>
  </div>
</template>

<script>
import MultipleChoice from '@/components/MultipleChoice'
import ScaleQuestion from '@/components/ScaleQuestion'
import SlideWaiting from '@/components/SlideWaiting'
import EvenBus from '@/eventBus'
import AudioControl from '@/components/AudioControl.vue'
import storage from '@/services/storage'

export default {
  components: {
    MultipleChoice,
    SlideWaiting,
    AudioControl,
    ScaleQuestion,
  },
  data() {
    return {
      status: 1,
    }
  },
  mounted() {
    this.checkVoting()

    EvenBus.$on('multiple-choice-voted', (data) => {
      this.checkVoting(data)
    })
  },
  destroyed() {
    EvenBus.$off('multiple-choice-voted')
  },
  methods: {
    checkVoting(data) {
      const slideId = this.$store.state.slide.id
      const presentationId = this.$store.state.presentation.id
      const answeredSlideIds = storage.getValueByPresentation(presentationId, 'answeredSlideIds', [])

      if (answeredSlideIds.includes(slideId) || data) {
        if (this.$store.state.presentation.lastSlide !== slideId) {
          this.$store.state.slide.multipleChoiceStatus = 2
        } else {
          this.$store.state.slide.isEndSlide = true
        }
        this.$store.dispatch('updateSlide', this.$store.state.slide)
      }
    },
  },
}
</script>

<style lang="scss" scoped>
@import "@/assets/scss/variables.scss";

h2, .title-desc {
  padding: 0 16px;
}

.no-data {
  padding: 16px;
}
.text-left {
  word-break: break-word;
  // white-space: pre-wrap;
  -o-word-wrap: normal;
  -ms-word-wrap: normal;
  word-wrap: normal;
}
.audio-control-slide {
  margin-bottom: 16px;
}

.progress-bar-time-limit {
  position: relative;
  margin-bottom: 16px;
  padding-top: 20px;
  border: 1px solid transparent;
}

</style>
